export const capitalizeFirstLetter = (val: string) =>
  String(val).charAt(0).toUpperCase() + String(val).slice(1);

export const hasNumber = (str: string) => /\d/.test(str);
export const hasSpecialCharacter = (str: string) =>/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?~]/.test(str);

export const validatePassword = (password: string) => 
  (!password || !(password.length > 8) || !hasNumber(password) || !hasSpecialCharacter(password)) ? false : true

export const validateEmail = (email: string) => (!email || !email.includes('@') ? false : true);